import Model from "./Model";

export default class Professor extends Model {
  constructor(professor) {
    super();
    Object.assign(this, professor);
  }
}
